$(document).ready(function () {

  // Popup
  $(".tz-click-here").on("click", function() {
    var popupId = $(this).data("popup-id");
    $("#" + popupId).addClass("model-open");
    $("body").css("overflow", "hidden");
  });
  
  $(".close-btn, .bg-overlay").click(function(){
      $(".custom-model-main").removeClass('model-open');
      $("body").css("overflow", "auto");
  });
  
  // Slider
  if ($("#owl-carousel").length) {
    $("#owl-carousel").owlCarousel({
      loop: true,
      margin: 0,
      dots: false,
      nav: false,
      items: 1,
      autoplay: true,
    });
  }

  // Pepper Tabs

  $(".w-tab-menu [data-w-tab]").on("click", function () {
    event.preventDefault();
    $(".spice-tab").removeClass("w--current");
    $(this).addClass("w--current");

    var tabAttribute = $(this).attr("data-w-tab");
    $(".spice-tab-content")
      .stop(true, true)
      .fadeOut(500)
      .removeClass("w--tab-active");

    $('.spice-tab-content[data-w-tab="' + tabAttribute + '"]')
      .stop(true, true)
      .fadeIn(500)
      .addClass("w--tab-active");

    checkTabAvailability();
  });

  $(".tab-next").on("click", function (event) {
    event.preventDefault();
    var currentTab = $(".spice-tab.w--current");
    var nextTab = currentTab.next("[data-w-tab]");

    if (nextTab.length === 0) {
      nextTab = $(".spice-tab").first();
    }
    nextTab.trigger("click");
  });

  $(".tab-prev").on("click", function (event) {
    event.preventDefault();
    var currentTab = $(".spice-tab.w--current");
    var prevTab = currentTab.prev("[data-w-tab]");

    if (prevTab.length === 0) {
      prevTab = $(".spice-tab").last();
    }
    prevTab.trigger("click");
  });

  function checkTabAvailability() {
    var currentTab = $(".spice-tab.w--current");
    var prevTab = currentTab.prev("[data-w-tab]");

    if (prevTab.length === 0) {
      $(".tab-prev").css("opactiy", "0.25");
    }

    var nextTab = currentTab.next("[data-w-tab]");

    if (nextTab.length === 0) {
      $(".tab-next").css("opactiy", "0.25");
    }
  }

  checkTabAvailability();

  // Home Slider Main Slider

  // var slideSpeed = $('.tz-home-slider').data('slide-speed');
  // console.log(slideSpeed);

  if ($('body').hasClass('index')) {
    var swiper = new Swiper(".tz-home-slider .tz-outer-slider.swiper-container", {
      loop: false,
      slidesPerView: 1,
      paginationClickable: true,
      spaceBetween: 20,
      grabCursor: true,
      autoHeight: true,
      // autoplay: {
      // delay: slideSpeed * 1000,
      // },
      pagination: {
        el: ".tz-home-slider .slider__pagination",
        clickable: true,
      }
    });
  
    if (swiper.slides.length <= 1) {
      $('.tz-home-slider .slider__controls').hide();
    }else{
      $('.tz-home-slider .slider__controls').show();
    }
  }

  // var innerslideSpeed = $('.tz-inner-slider').data('slide-speed');

  var innerSwiper = new Swiper(".tz-inner-slider.swiper-container", {
    loop: false,
    slidesPerView: 1,
    spaceBetween: 20,
    grabCursor: true,
    autoHeight: true,
    autoplay: {
    delay: 4000,
    },
    pagination: false,
  });

  // Home Slider Customer Slider
  new Swiper(".tz-customer-review-slider.swiper-container", {
      loop: true,
      spaceBetween: 40,
      grabCursor: true,
      centeredSlides: true,
      navigation: {
          nextEl: ".swiper-next",
          prevEl: ".swiper-prev",
      },
      pagination: {
          clickable: true,
      },
      breakpoints: {
          1920: {
              slidesPerView: 3,
              spaceBetween: 40
          },
          1028: {
              slidesPerView: 2,
              spaceBetween: 40
          },
          480: {
              slidesPerView: 1,
              spaceBetween: 40
          }
      }
  });

  
  
});


/* SpiceQuest: keep Shop Pay installment graphics at their intended size. */
(function () {
  'use strict';

  var watchedHosts = new WeakSet();
  var watchedRoots = new WeakSet();

  function setSize(element, width, height) {
    if (!element) return;
    element.setAttribute('width', width);
    element.setAttribute('height', height);
    element.style.setProperty('display', 'inline-block', 'important');
    element.style.setProperty('width', width + 'px', 'important');
    element.style.setProperty('height', height + 'px', 'important');
    element.style.setProperty('min-width', width + 'px', 'important');
    element.style.setProperty('max-width', width + 'px', 'important');
    element.style.setProperty('min-height', height + 'px', 'important');
    element.style.setProperty('max-height', height + 'px', 'important');
    element.style.setProperty('vertical-align', 'middle', 'important');
    element.style.setProperty('flex', '0 0 ' + width + 'px', 'important');
  }

  function constrainPaymentTerms(root) {
    root.querySelectorAll('svg[role="img"][viewBox="0 0 60 25"]').forEach(function (logo) {
      setSize(logo, 34, 14);
      if (logo.parentElement) {
        logo.parentElement.style.setProperty('display', 'inline-flex', 'important');
        logo.parentElement.style.setProperty('width', '34px', 'important');
        logo.parentElement.style.setProperty('height', '14px', 'important');
        logo.parentElement.style.setProperty('max-width', '34px', 'important');
        logo.parentElement.style.setProperty('max-height', '14px', 'important');
        logo.parentElement.style.setProperty('vertical-align', 'middle', 'important');
        logo.parentElement.style.setProperty('overflow', 'hidden', 'important');
      }
    });
    root.querySelectorAll('button[aria-label="View sample plans"] svg[viewBox="0 0 20 20"]').forEach(function (icon) {
      setSize(icon, 20, 20);
    });
  }

  function watchHost(host) {
    if (!host || watchedHosts.has(host)) return;
    watchedHosts.add(host);
    var attempts = 0;
    var connect = function () {
      var root = host.shadowRoot;
      if (!root) {
        attempts += 1;
        if (attempts < 40) window.setTimeout(connect, 250);
        return;
      }
      constrainPaymentTerms(root);
      if (!watchedRoots.has(root)) {
        watchedRoots.add(root);
        new MutationObserver(function () {
          constrainPaymentTerms(root);
        }).observe(root, { childList: true, subtree: true });
      }
    };
    connect();
  }

  function scan(root) {
    if (root.matches && root.matches('shopify-payment-terms')) watchHost(root);
    if (root.querySelectorAll) root.querySelectorAll('shopify-payment-terms').forEach(watchHost);
  }

  function start() {
    scan(document);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) scan(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
